module.exports = "<chassis-core-resource-form\n    [entityName]=\"entityName\"\n    [static]=\"static\"\n    [entity]=\"entity\"\n    (submit)=\"onSubmit($event)\"\n></chassis-core-resource-form>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/resources/pages/create/create.page.html
// module id = ./libs/chassis-core/src/app/resources/pages/create/create.page.html
// module chunks = main